// src/components/DatabaseExplorer/DynamicDataTable.jsx

import React from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { TbCaretUpDownFilled } from "react-icons/tb";

import {
  getColumnName,
  getColumnType,
  formatHeader,
  displayValue,
  isPrimaryKey,
} from "./databaseExplorerUtils";
import DownloadExcelFromData from "../Extra/DownloadExcelFromData";

export default function DynamicDataTable({
  columns = [],
  rows = [],
  page,
  pageSize,
  sortConfig,
  onSort,
  onView,
  hiddenColumns = ["insert_timestamp", "updated_time_stamp"],
}) {
  // Remove columns whose names match hiddenColumns
  const visibleColumns = columns.filter((column) => {
    const name = getColumnName(column);

    return !hiddenColumns.some(
      (hiddenName) =>
        String(hiddenName).toLowerCase() === String(name).toLowerCase(),
    );
  });

  if (!visibleColumns.length) return null;

  return (
    <div className="table-responsive">
      <table className="table table-hover table-striped align-middle mb-0">
        <thead>
          <tr>
            <th className="bg-light px-3">#</th>

            {visibleColumns.map((column) => {
              const name = getColumnName(column);
              const sorted = sortConfig?.key === name;

              return (
                <th
                  key={name}
                  className="bg-light text-nowrap"
                  aria-sort={
                    sorted
                      ? sortConfig.direction === "asc"
                        ? "ascending"
                        : "descending"
                      : "none"
                  }
                >
                  <button
                    type="button"
                    className="btn btn-sm p-0 border-0 fw-bold text-dark text-nowrap"
                    onClick={() => onSort(column)}
                  >
                    {formatHeader(name)}

                    <span className="ms-2 text-primary">
                      {sorted ? (
                        sortConfig.direction === "asc" ? (
                          <FiChevronUp />
                        ) : (
                          <FiChevronDown />
                        )
                      ) : (
                        <TbCaretUpDownFilled className="text-secondary" />
                      )}
                    </span>
                  </button>

                  <div className="small text-secondary fw-normal mt-1">
                    {getColumnType(column).length > 20
                      ? `${getColumnType(column).slice(0, 20)}...`
                      : getColumnType(column)}
                    {isPrimaryKey(column) ? " · PK" : ""}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, index) => (
            <tr key={`${page}-${index}`}>
              <td className="text-secondary px-3">
                {(page - 1) * pageSize + index + 1}
              </td>

              {visibleColumns.map((column) => {
                const name = getColumnName(column);
                const value = row[name];

                return (
                  <td
                    key={name}
                    className="text-nowrap"
                    style={{ maxWidth: 300 }}
                    title={typeof value === "string" ? value : undefined}
                  >
                    <div className="text-truncate" style={{ maxWidth: 280 }}>
                      {displayValue(value)?.replace("T00:00:00.000Z", "")}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}

          {rows.length === 0 && (
            <tr>
              <td
                colSpan={visibleColumns.length + 1}
                className="text-center py-5"
              >
                <h6 className="fw-semibold">No matching records</h6>

                <p className="text-secondary small mb-0">
                  Try changing your search or filters.
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
